<template>
    <div>
      <div class="px-4">
        <div class="btn-home col-md-12 mt-3 mb-2 d-flex justify-content-end">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
        <div id="div-modal-cxc" class="d-flex justify-content-center">
          <div id="div-cxc" class=" w-100">
              
              <div class="card-body w-100">
                  <div class="row">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="col-md-12 card" id="content-timelinetable ">
                              <div class="card-header text-white text-center h5 bg-main">
                                  <div class="row d-flex align-items-center text-center" style="height: 100%;">
                                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                          <strong>STOCK</strong>
                                      </div>
                                  </div>
                              </div>
                              <div class="list-group mb-3 scroll-container  ">

                                  <div class="row  responsive-search  px-3 mt-2 mx-0">
                                        <div class=" col-xl-8 px-0">
                                          <input  @input="mtdGetDatastock" v-model="subsubcategorieName" type="text" class="form-control" id="exampleFormControlInput1" placeholder="Ingrese Producto">
                                        </div>
                                        <div class="col-xl-4 px-0 ps-xl-1 pt-xl-0 pt-1">
                                            <select v-model="almacen_id" class="form-control" aria-label="Default select example">
                                              <option v-for=" (item,index) in dataAlmacenes" :key="index" :value="item.id">{{ item.name }}</option> 
                                            </select>
                                        </div>
                                  </div>
                                  <div >
                                    <div v-if="stock.length > 0" class="row mx-0 py-2 px-3 ">
                                      <div v-for="(item,index) in stock " :key="index"  class="col-xl-2 col-lg-2 px-1 py-1 ">
                                          <div   class=" card p-2" >
                                                <div class="d-flex w-100 justify-content-between align-items-center mb-3">
                                                    <h6 class="mb-2 fw-bold text-center" style="font-size: 12px" >
                                                        {{ item.product_detail.subsubcategorie.name }}
                                                    </h6>
                                                </div>
                                                <div  class="">
                                                  <div class="icon-book d-flex justify-content-center align-items-center mb-3">
                                                        <img src="../../../assets/caja.png" alt="" class="img-fluid-bed-sop rounded-start">
                                                  </div>
                                                  <div >
                                                    
                                                    <h5 class="mb-2" style="font-size: 12px">
                                                        <strong>LOTE:</strong>
                                                        {{ item.dispatch_detail.lote }}
                                                    </h5>        
                                                    <h5 class="mb-2" style="font-size: 12px">
                                                        <strong>STOCK :</strong>
                                                    </h5>
                                                    <h5 style="font-size: 12px" class=" ps-2">
                                                      <li v-if="item.productunit.unit_id !=1"> ( {{ item.new_quantity_unit  }} ) {{ item.productunit.unit.name }}</li>
                                                      <li> ( {{ item.new_quantity }} ) UNIDADES</li>
                                                    </h5>
                                                    <div class="mt-1">
                                                       <button @click="mtdaddunit(item)" v-if="item.new_quantity_unit || item.new_quantity_unit !=0 " type="button" class="btn  btn-sm w-100 btn-info">TRANSFORMA A UNIDADES</button>
                                                    </div>
                                                  </div>
                                                </div>
                                          </div>
                                        
                                      </div>
                                    </div>
                                    <div v-else>
                                      <div v-if="msg==1" class="text-center "> No hay resultados</div>
                                      <div v-if="msg==0" class="text-center ">Ingrese Producto</div>
                                    </div>
  
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
  
          </div>
        </div>
      </div>
     
     
      <SweetAlert :swal="swal" @mtdaddquantityunit="mtdaddquantityunit" ref="SweetAlert" />
    </div>
  </template>
  <script>
  import { mapActions } from "vuex";
  
  import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
  export default {
    name: "c-Pharmacy-cReci",
    components: {
      SweetAlert,
    },
  
    data() {
      return {    
        dataAlmacenes :[],
        almacen_id:4,
        subsubcategorieName:'',
        swal:null,
        stock:[],
        msg:0
      };
    },
  
  
    computed:{
      
    },
    created(){
        this.mtdGetData();
    },
    methods: {
      ...mapActions(["get", "post"]),
      //metodo retornar a Home
      returnHome: function () {
        this.$emit("returnHome");
      },

      mtdGetData: function () {
            this.get({
                url: this.$store.getters.get__url + "/Pharmacy/maintenance/mtdGetAlmaPharmacy/"+ this.$store.getters.get__campus,
                token: this.$store.getters.get__token,
            })
            .then((response) => {
              this.dataAlmacenes = [];
              response.data.forEach(element => {
                 if(element.id != 1){
                  this.dataAlmacenes.push(element);
                 }
               });      
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },
      mtdGetDatastock: function () {
        if (this.subsubcategorieName.length >= 4) {
          let data = {
              almacen_id: this.almacen_id,
              subsubcategorieName:this.subsubcategorieName
          }
           this.post({
            url: this.$store.getters.get__url + "/Pharmacy/medic/stock",
            token: this.$store.getters.get__token,
            params:data
          })
            .then((response) => {
              if(response.statusCode == 200){
                this.stock = response.data;
                this.msg = 1
              }
            })
            .catch((errors) => {
              this.$refs.SweetAlert.showError(errors);
            });

        }else{
          this.msg =0
        }
      },

      mtdaddunit:function(item){
          this.$refs.SweetAlert.showStock(item);
      },
      mtdaddquantityunit:function(item){
        this.post({
            url: this.$store.getters.get__url + "/Pharmacy/medic/editStock",
            token: this.$store.getters.get__token,
            params:item
          })
            .then((response) => {
              if(response.statusCode == 200){
                this.mtdGetDatastock();
              }
            })
            .catch((errors) => {
              this.$refs.SweetAlert.showError(errors);
            });
      }
    }
  };
  </script>
  <style scoped>
  .bootom {
    background-color: #900052 !important;
    border: 0.5px solid #900052 !important;
  }
  .spam {
    background: #900052;
    color: #ffffff;
    width: 180px;
    line-height: 20px;
    justify-content: center;
    border-radius: 1rem;
  }
  .badge-danger {
      background-color: #fa0821;
      color: #ffffff;
      font-size: 12px;
      border-radius: 0.50rem;
      padding: 0.2rem;
      font-weight: bold;
      align-items: center;
      display: inline-flex;
    }
    .badge-warning {
      background-color: #f7ba03;
      color: #000000;
      font-size: 12px;
      border-radius: 0.50rem;
      padding: 0.2rem;
      font-weight: bold;
      align-items: center;
      display: inline-flex;
    }
    .badge-success {
      background-color: #0bc837;
      color: #ffffff;
      font-size: 12px;
      border-radius: 0.50rem;
      padding: 0.2rem;
      font-weight: bold;
      align-items: center;
      display: inline-flex;
    }
    .badge-type-medic {
      background-color: #096df1;
      color: #ffffff;
      font-size: 7.5px;
      border-radius: 0.50rem;
      padding: 0.2rem;
      font-weight: bold;
      align-items: center;
      display: inline-flex;
    }
    .badge-type-insumo {
      background-color: #abcd06;
      color: #ffffff;
      font-size: 7.5px;
      border-radius: 0.50rem;
      padding: 0.2rem;
      font-weight: bold;
      align-items: center;
      display: inline-flex;
    }
    .badge-secondary {
      background-color: #838383;
      color: #ffffff;
      font-size: 12px;
      border-radius: 0.50rem;
      padding: 0.2rem;
      font-weight: bold;
      align-items: center;
      display: inline-flex;
    }
  
    .scroll-container {
      max-height: 410px;
      overflow-y: auto;
      overflow-x: hidden; 
      width: 100%; 
      box-sizing: border-box; 
  }
  
  .recipe-item-orange {
      background-color: #fff4de; 
  }
  
  .recipe-item-green {
      background-color: #ebfde5; 
  }
  
  .icon-custom{
      color: #900052; 
      margin-left: 0.3em;
  }
  
  .hover-card:hover{
   background-color: #f3f9fd;
  }
  .bg-lote{
    background-color: #D2E0F2;
  }
  
  </style>
  